import { ArrowRight, CheckCircle2, Clock, Lock, Sparkles } from "lucide-react";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

// `identifier` is the Sydney-calendar Friday (YYYY-MM-DD) computed server-side.
export function nextWindowLabel(identifier) {
  const [y, m, d] = identifier.split("-").map(Number);
  const fri = new Date(Date.UTC(y, m - 1, d + 7));
  const sun = new Date(Date.UTC(y, m - 1, d + 9));
  const fmt = (dt) => `${dt.getUTCDate()} ${MONTHS[dt.getUTCMonth()]}`;
  return `Friday ${fmt(fri)} - Sunday ${fmt(sun)}`;
}

export function LockedState({ identifier }) {
  return (
    <section className="surface-card mt-10 p-8 md:p-10" data-testid="weekly-locked-state">
      <div className="flex items-start gap-5">
        <div className="h-12 w-12 rounded-full bg-[#C8965A]/15 text-[#C8965A] flex items-center justify-center shrink-0" aria-hidden>
          <Lock size={22} strokeWidth={1.6} data-testid="weekly-locked-icon" />
        </div>
        <div>
          <h2 className="font-serif text-2xl md:text-3xl text-brand-ink" data-testid="weekly-locked-next">
            Next Check In {nextWindowLabel(identifier)}
          </h2>
          <p className="mt-4 text-brand-ink-muted text-base md:text-lg leading-relaxed max-w-2xl" data-testid="weekly-locked-support">
            If you need support in the meantime please reach out in our Community or message Justine directly
          </p>
        </div>
      </div>
    </section>
  );
}

// Stage 2C availability states for a fully onboarded Active client.

export function OpenState({ preferredName, status, onBegin }) {
  const name = preferredName || "there";
  return (
    <section className="surface-card mt-10 p-8" data-testid="weekly-open-state">
      <div className="flex items-start gap-4">
        <Sparkles className="text-brand-primary shrink-0 mt-1" size={22} strokeWidth={1.5} />
        <div>
          <h2 className="font-serif text-2xl md:text-3xl text-brand-ink">Your Weekly Check-In is open, {name}.</h2>
          <p className="mt-3 text-brand-ink-muted text-base md:text-lg leading-relaxed max-w-2xl">
            Eight reflective questions, one at a time. Closes {status.window.closes_display}.
          </p>
          <button type="button" onClick={onBegin} className="btn-primary inline-flex items-center gap-2 mt-6" data-testid="weekly-begin-btn">
            Begin my Weekly Check-In <ArrowRight size={16} strokeWidth={2} />
          </button>
        </div>
      </div>
    </section>
  );
}

export function ClosedState({ status }) {
  return (
    <section className="surface-card mt-10 p-8" data-testid="weekly-closed-state">
      <div className="flex items-start gap-4">
        <Clock className="text-brand-primary shrink-0 mt-1" size={22} strokeWidth={1.5} />
        <div>
          <h2 className="font-serif text-2xl md:text-3xl text-brand-ink">Your Weekly Check-In is currently closed.</h2>
          <p className="mt-3 text-brand-ink text-base md:text-lg leading-relaxed max-w-2xl" data-testid="weekly-next-opens">
            Your next Weekly Check-In opens on {status.window.next_opens_display}.
          </p>
        </div>
      </div>
    </section>
  );
}

export function CompletedState({ preferredName }) {
  const name = preferredName || "there";
  return (
    <section className="surface-card mt-10 p-8" data-testid="weekly-completed-state">
      <div className="flex items-start gap-4">
        <CheckCircle2 className="text-emerald-700 shrink-0 mt-1" size={22} strokeWidth={1.5} />
        <div>
          <h2 className="font-serif text-2xl md:text-3xl text-brand-ink">This week&apos;s check-in is complete, {name}.</h2>
          <p className="mt-3 text-brand-ink-muted text-base md:text-lg leading-relaxed max-w-2xl">
            Thank you for showing up for yourself. Your personalised Weekly Insights are below. Your next Weekly Check-In will open on Friday at 4pm.
          </p>
        </div>
      </div>
    </section>
  );
}
